export default {"src":"/_next/static/media/motion-blur-1.3fc42cc4.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};